import { useMemo, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";
import { permissionChecker } from "helpers/common";
import { useSelector } from "react-redux";

export const useIntegrationPermissions = (integration) => {
  const { user } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);
  const { sharedIntegrations } = useSelector((store) => store?.portal?.integrations);

  const permissions = useMemo(() => {
    if (!user || !integration) {
      return {
        canEdit: false,
        canDelete: false,
        canShare: false,
        canOpenMenu: false,
        isOwner: false
      };
    }

    const isOwner = integration?.create_user_id === user?.cxfUserId;
    const foundSharedIntegration = sharedIntegrations.find(
      (shared) =>
        shared.integration_id === integration.id && shared.shared_user_id === user.cxfUserId
    );
    const isEditor = foundSharedIntegration?.access_type === "editor";

    const canEdit =
      permissionChecker(userPermissions, PERMISSIONS.EDIT_ANY_INTEGRATIONS) || isOwner || isEditor;

    const canDelete =
      permissionChecker(userPermissions, PERMISSIONS.DELETE_ANY_INTEGRATIONS) ||
      isOwner ||
      isEditor;

    const canShare =
      permissionChecker(userPermissions, PERMISSIONS.SHARE_ANY_INTEGRATIONS) || isOwner;

    return {
      canEdit,
      canDelete,
      canShare,
      canOpenMenu: canEdit || canDelete || canShare,
      isOwner
    };
  }, [user, integration, userPermissions, sharedIntegrations]);

  return permissions;
};
